export default "__VITE_ASSET__CtIvzxL4__"